import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useSuperIntl } from "../../_";
import { DrawerForm } from '@ant-design/pro-components';
import { Button, Table, Tag, Typography } from 'antd';
import _ from 'lodash';
import React, { useRef } from 'react';
import { useStyles } from "./Operator.style";
export var ProFormSelectButtonOperator = function ProFormSelectButtonOperator(properties) {
  var _properties$fieldProp, _properties$fieldProp2, _properties$fieldProp3, _properties$fieldProp4, _properties$fieldProp5;
  var intl = useSuperIntl();
  var label = intl.formatMessage({
    id: 'Select {name}'
  }, {
    name: properties.label
  });
  var maxCount = (_properties$fieldProp = properties.fieldProps) !== null && _properties$fieldProp !== void 0 && _properties$fieldProp.mode ? (_properties$fieldProp2 = (_properties$fieldProp3 = properties.fieldProps) === null || _properties$fieldProp3 === void 0 ? void 0 : _properties$fieldProp3.maxCount) !== null && _properties$fieldProp2 !== void 0 ? _properties$fieldProp2 : Math.pow(2, 10) : 1;
  var selectedEntities = useRef([]);
  var storedEntities = properties.value || [];
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  var transform = function transform(entity) {
    if (entity) {
      return {
        id: _.get(entity, properties.fieldNames.id),
        description: _.get(entity, properties.fieldNames.description),
        name: _.get(entity, properties.fieldNames.name)
      };
    } else {
      return null;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", null, storedEntities.map(function (entity) {
    // -
    // > 名称
    var transformedEntity = transform(entity) || Object.create(null);
    //
    return /*#__PURE__*/React.createElement(Tag, {
      closable: true,
      key: transformedEntity.id,
      onClose: function onClose(event) {
        // -
        // > -
        event.preventDefault();
        // > -
        event.stopPropagation();
        // -
        properties.onChange(storedEntities.filter(function (storedEntity) {
          var _transform;
          return transformedEntity.id !== ((_transform = transform(storedEntity)) === null || _transform === void 0 ? void 0 : _transform.id);
        }), []);
      },
      style: {
        marginTop: 0,
        fontSize: 14,
        maxWidth: 240,
        marginRight: 4,
        fontWeight: 400,
        marginBottom: 4,
        lineHeight: '22px',
        padding: '4px 12px',
        whiteSpace: 'normal',
        color: 'rgb(74, 76, 79)',
        borderColor: 'rgb(240, 242, 245)',
        backgroundColor: 'rgb(240, 242, 245)'
      }
    }, /*#__PURE__*/React.createElement(Typography.Text, {
      style: {
        // maxWidth: 'calc(100% - 20px)',
      },
      ellipsis: true,
      title: String(transformedEntity.name)
    }, transformedEntity.name));
  }), storedEntities.length === 1 && !((_properties$fieldProp4 = properties.fieldProps) !== null && _properties$fieldProp4 !== void 0 && _properties$fieldProp4.mode) && /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, [transform(storedEntities[0])].map(function (element) {
    return /*#__PURE__*/React.createElement("span", {
      key: element === null || element === void 0 ? void 0 : element.id
    }, element === null || element === void 0 ? void 0 : element.description);
  }))), /*#__PURE__*/React.createElement("div", null, storedEntities.length < maxCount && /*#__PURE__*/React.createElement(DrawerForm, {
    title: label,
    trigger: /*#__PURE__*/React.createElement(Button, {
      type: "dashed"
    }, label),
    onFinish: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            //
            properties.onChange([].concat(_toConsumableArray(storedEntities), _toConsumableArray(selectedEntities.current)), []);
            //
            return _context.abrupt("return", true);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    drawerProps: {
      destroyOnClose: true,
      bodyStyle: {
        padding: 0
      }
    }
  }, /*#__PURE__*/React.cloneElement(properties.children, _.merge({
    params: {
      searcher: [{
        key: properties.fieldNames.id,
        operator: '⊉',
        value: storedEntities.map(function (storedEntity) {
          var _transform2;
          return (_transform2 = transform(storedEntity)) === null || _transform2 === void 0 ? void 0 : _transform2.id;
        }).join(',')
      }]
    },
    rowSelection: {
      type: (_properties$fieldProp5 = properties.fieldProps) !== null && _properties$fieldProp5 !== void 0 && _properties$fieldProp5.mode ? 'checkbox' : 'radio',
      selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
      onChange: function onChange(_selectedRowKeys_, selectedRows) {
        return selectedEntities.current = selectedRows;
      }
    }
  }, properties.children.props)))));
};